(function(window, $) { 'use strict';

    function Clamp() {}

    Clamp.prototype.init = function( $selector ) {

        $selector = $selector || $('[data-clamp]');

        // Clamp it
        $selector.each(function() {
            $clamp(this, {
                clamp: $(this).data('clamp')
            });
        });

    };

    window.Clamp = Clamp;

})(window, jQuery);
